import styled from "@emotion/styled";

export const ListWrapper = styled("div")`
    padding: 40px 16px 120px 16px;
`;
